// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UnsubscribeReminders_wrapper__JnzvW","link":"UnsubscribeReminders_link__6oBwm"};